module.exports = __webpack_public_path__ + "static/media/icons_comercializacion.67bea8c1.png";